import React, {useState} from "react";
import Sugar from 'sugar';

import SearchFilter from "./SearchFilter";
import SearchSort from "./SearchSort";
import SearchResultList from "./SearchResultList";
import SearchResultPlaceholder from "./SearchResultPlaceholder";

import LinkSearchResult from "./LinkSearchResult";
import AccordionSearchResult from "./AccordionSearchResult";

import Deploy from "../Deploy"

import { useQueriedData } from "../data/DataHooks"

import { isSameScorecard } from "../Helpers";

Sugar.extend();


function SearchResults( {searchResultData, selection, setSelection, sortBy, setSortBy, limit, source, displayFilters } )
{
  const { data, isLoading } = searchResultData;
  const sortedData = data.sortBy( sortBy.field, sortBy.desc );
  const displayLimit = limit == 0 ? 100 : limit;


  return (
    <div className="search-results">
      {
        displayFilters &&
      <div className="side-by-side">
        <SearchFilter selection={ selection } onSetSelection={ setSelection }/>
        <SearchSort sort={sortBy} onSelectSort={ setSortBy }/>
      </div>
    }

      { isLoading &&
        <>
        { (5).downto(0).map( i => <SearchResultPlaceholder key={i}/> ) }
        </>
      }

      { !isLoading &&
        <>
        <Deploy.Widget>
          <SearchResultList Template={ AccordionSearchResult } majors={ sortedData } highlight={sortBy.field} limit={displayLimit} source={source}/>
        </Deploy.Widget>

        <Deploy.Tool>
          <SearchResultList Template={ LinkSearchResult } majors={ sortedData } highlight={sortBy.field} limit={displayLimit}/>
        </Deploy.Tool>
        </>
      }

    </div>

  );
}

SearchResults.defaultProps = {
  limit: 0,
  displayFilters: true
}

export default SearchResults;
